import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "shared-banner-wrapper tw pointer-events-none relative w-full overflow-hidden desktop:-top-4"
}
const _hoisted_2 = { class: "bottom-unset pointer-events-none fixed bottom-0 m-auto flex w-full max-w-[1408px] justify-center px-2 py-2 desktop:relative desktop:justify-end desktop:py-4" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "overflow-hidden py-4 pr-11" }
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]

import { ref, useTemplateRef, onMounted, computed, onBeforeUnmount, nextTick } from "vue";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants";

import { BannerData } from "@/SharedBannerApp/types/banner.type";
import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";
import CloseButton from "@SharedVueComponents/CloseButton/CloseButton.vue";

import { handleSuccessfulKeycloakProcess } from "@/SharedBannerApp/services/banner-query-listener";


export default /*@__PURE__*/_defineComponent({
  __name: 'SharedBanner',
  setup(__props) {

const uid = ref();
const bannerElement = useTemplateRef("bannerElement");
const banner = ref<BannerData>();
const bannerFocusVisible = ref(false);
const bannerOpen = ref(false);
const iconName = computed(() => {
	switch (banner.value?.type) {
		case "alert":
			return "circle-percent";
		case "success":
			return "checkmark-circled";
		case "percent":
			return "circle-percent";
		default:
			return undefined;
	}
});
const bannerLabelId = computed(() => `bannerLabel-${uid.value}`);
const bannerDescriptionId = computed(() => `bannerDescription-${uid.value}`);
const iconClass = computed(() => (banner.value ? `diagonal-${banner.value.type}` : ""));

const _addBanner = async (data: { data: BannerData }) => {
	banner.value = data.data;
	if (!data.data.hideBannerFocus) bannerFocusVisible.value = true;
	await nextTick();
	uid.value = Date.now();
	bannerOpen.value = true;
	bannerElement.value?.show();
	bannerElement.value?.focus();
};

const closeBanner = () => {
	bannerElement.value?.addEventListener("animationend", _removeBanner);
	bannerElement.value?.addEventListener("animationcancel", _removeBanner);
	bannerOpen.value = false;
};

const _removeBanner = () => {
	bannerElement.value?.removeEventListener("animationend", _removeBanner);
	bannerElement.value?.removeEventListener("animationcancel", _removeBanner);
	bannerElement.value?.close();
	banner.value = undefined;
};

onMounted(() => {
	OcmMessenger.subscribe(messengerPublicationTypes.ADD_BANNER, _addBanner);
	OcmMessenger.subscribe(messengerPublicationTypes.ROUTE_CHANGE, closeBanner);
	handleSuccessfulKeycloakProcess();
});

onBeforeUnmount(() => {
	OcmMessenger.unsubscribe(messengerPublicationTypes.ADD_BANNER, _addBanner);
	OcmMessenger.unsubscribe(messengerPublicationTypes.ROUTE_CHANGE, closeBanner);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#shared-banner-container" }, [
    (banner.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("dialog", {
              ref_key: "bannerElement",
              ref: bannerElement,
              class: _normalizeClass(["ocm-body1 pointer-events-auto relative m-0 grid min-h-5 max-w-96 grid-cols-[4.8571428571rem,1fr] rounded-lg bg-gray-beton shadow focus-visible:outline-none px360:min-w-86 desktop:min-w-0", {
						'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current':
							bannerFocusVisible.value,
						'shared-banner-animation-enter-active': bannerOpen.value,
						'shared-banner-animation-leave-active': !bannerOpen.value,
					}]),
              tabindex: "-1",
              "aria-label": `${banner.value?.headline} ${banner.value?.message}`
            }, [
              _createVNode(CloseButton, {
                class: "right-1 top-1 border-transparent",
                style: {"background-color":"transparent !important","width":"2.5714286rem !important","height":"2.5714286rem !important"},
                inverted: "",
                "aria-label": "Nachricht schließen",
                onClick: _withModifiers(closeBanner, ["stop"])
              }),
              _createElementVNode("div", {
                class: _normalizeClass([iconClass.value, "grid items-center rounded-l-lg px-2.5"])
              }, [
                _createVNode(SvgIcon, {
                  class: "size-7",
                  "icon-name": iconName.value
                }, null, 8, ["icon-name"])
              ], 2),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  id: bannerLabelId.value,
                  class: "ocm-headline3 mb-1 truncate"
                }, _toDisplayString(banner.value?.headline), 9, _hoisted_5),
                _createElementVNode("div", {
                  id: bannerDescriptionId.value,
                  class: "truncate"
                }, _toDisplayString(banner.value?.message), 9, _hoisted_6)
              ])
            ], 10, _hoisted_3)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})